var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 104,
    viewBox: "0 0 61 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1690)",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.981 94.06H3.701v-6.72c0-11.04 2.64-18.36 13.32-32.16l9.6-12.6c5.16-6.96 6.72-9.84 6.72-16.56v-1.68c0-5.16-1.56-7.44-6.12-7.44-4.44 0-6 2.4-6 7.44v11.4h-15V22.9c0-10.32 4.44-18.96 19.44-18.96h2.4c15.96 0 21.48 7.44 21.48 20.04v1.44c0 10.8-3.24 16.8-10.08 24.84-3.48 4.08-6.72 7.8-10.2 11.64-10.2 11.16-11.64 15.6-11.64 18.72h18.24V64.78h15.12v29.28z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.981 94.06H3.701v-6.72c0-11.04 2.64-18.36 13.32-32.16l9.6-12.6c5.16-6.96 6.72-9.84 6.72-16.56v-1.68c0-5.16-1.56-7.44-6.12-7.44-4.44 0-6 2.4-6 7.44v11.4h-15V22.9c0-10.32 4.44-18.96 19.44-18.96h2.4c15.96 0 21.48 7.44 21.48 20.04v1.44c0 10.8-3.24 16.8-10.08 24.84-3.48 4.08-6.72 7.8-10.2 11.64-10.2 11.16-11.64 15.6-11.64 18.72h18.24V64.78h15.12v29.28z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1690",
    x: -4.799,
    y: -4.56,
    width: 65.28,
    height: 108.12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1690"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1690",
    result: "effect2_dropShadow_2805_1690"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1690",
    result: "shape"
  })))));
}
Svg2.displayName = '2';
export default Svg2;